//src/Components/Popups/useCreateModal.tsx
import { useCreatePopup } from './useCreatePopup';

export default function useCreateModal<T>(options?: {
  name?: string;
  type?: 'modal' | 'dropdown';
  hooks?: {
    onClose?: () => void;
  };
}) {
  return useCreatePopup<T>({ ...options, type: 'modal' });
}
